class InventoryStatus {
  constructor() {
    this.statusElement = document.querySelector('[data-inventory-status="true"]');
    if (!this.statusElement) {
      return;
    }

    this.physicalStoreElement = document.querySelector('.delivery-option__physical-store');
    this.deliveryElement = document.querySelector('.delivery-option__delivery');
    this.deliveryOptionsElement = document.querySelector('.delivery-options');
    this.couldNotLoadText = this.statusElement.getAttribute('data-could-not-load-text');
    this.originalDeliveryText = this.statusElement.getAttribute('data-delivery-title') || '';
    this.originalPhysicalStoreText = this.statusElement.getAttribute('data-click-collect-title') || '';
    this.articleType = this.statusElement.getAttribute('data-article-type') || '';
    this.currentVariantId = this.statusElement.getAttribute('data-variant-id') || '';

    this.adminHandler = new DreambabyAdminRequestHandler();

    try {
      this.variantMetafields = JSON.parse(this.statusElement.getAttribute('data-variants') || '{}');
    } catch (e) {
      this.variantMetafields = {};
    }

    this.init();

    subscribe(PUB_SUB_EVENTS.variantChange, this.updateInventory.bind(this));
  }

  updateInventory(event) {
    this.deliveryOptionsElement.classList.add('is-loading');
    this.statusElement.dataset.sku = event.data.variant.sku;
    this.statusElement.dataset.variantId = event.data.variant.id;
    this.currentVariantId = event.data.variant.id;
    this.init();
  }

  updateDeliveryOptions(physicalStoreStock, deliveryStock) {
    if (this.physicalStoreElement) {
      this.physicalStoreElement.classList.toggle('delivery-option--no-stock', physicalStoreStock <= 0);
    }

    if (this.deliveryElement) {
      this.deliveryElement.classList.toggle('delivery-option--no-stock', deliveryStock <= 0);
    }
  }

  calculateStockTotals(inventoryLevels) {
    let totalStock = 0;
    let physicalStoreStock = 0;
    let deliveryStock = 0;

    inventoryLevels.forEach(level => {
      const quantity = parseInt(level.quantity) || 0;
      totalStock += quantity;

      if (level.location.isPhysicalStore) {
        physicalStoreStock += quantity;
      } else {
        deliveryStock += quantity;
      }
    });

    return { totalStock, physicalStoreStock, deliveryStock };
  }

  formatStock(stock) {
    if (stock <= 0) {
      return '';
    };

    return ` (${stock > 50 ? '> 50' : stock})`;
  }

  async init() {
    // MSYDB-667 - Disable features, keep bugfixes
    /* if(shouldHideVariant(this.variantMetafields[this.currentVariantId], this.articleType)) {
        this.deliveryOptionsElement.classList.add('is-hidden');
        return;
    }
    this.deliveryOptionsElement.classList.remove('is-hidden'); */

    try {
      const data = await this.adminHandler.getInventory({
        sku: this.statusElement.dataset.sku
      });

      if (!data.inventoryLevels) {
        this.handleNoInventory();
        throw new Error('No inventory levels found for this product');
      }

      const { totalStock, physicalStoreStock, deliveryStock } = this.calculateStockTotals(data.inventoryLevels);

      const hasPhysicalStores = data.inventoryLevels.some(inventoryLevel => inventoryLevel.location.isPhysicalStore);

      const statusText = document.querySelector('.dreambaby-store-inventory-status__text');
      if (statusText) {
        this.originalStatusText = statusText.textContent;
        statusText.textContent = `${this.originalStatusText} ${this.formatStock(totalStock)}`;
      }

      this.updateDeliveryOptions(physicalStoreStock, deliveryStock);

      const physicalStoreTitle = document.querySelector('.delivery-option__physical-store .delivery-option__title');
      if (physicalStoreTitle) {
        physicalStoreTitle.textContent = `${this.originalPhysicalStoreText} ${this.formatStock(physicalStoreStock)}`;
      }

      if (hasPhysicalStores) {
        this.physicalStoreElement.classList.remove('is-hidden');
      }

      const deliveryTitle = document.querySelector('.delivery-option__delivery .delivery-option__title');
      if (deliveryTitle) {
        deliveryTitle.textContent = `${this.originalDeliveryText} ${this.formatStock(deliveryStock)}`;
      }

      this.deliveryOptionsElement.classList.remove('is-loading');
    } catch (error) {
      this.deliveryOptionsElement.classList.remove('is-loading');
      console.error('Error fetching inventory:', error);
    } finally {
      this.statusElement.classList.remove('is-loading');
    }
  }
  handleNoInventory() {
    this.physicalStoreElement.classList.add('is-hidden');

    const deliveryTitle = document.querySelector('.delivery-option__delivery .delivery-option__title');
    if (deliveryTitle) {
      deliveryTitle.textContent = this.originalDeliveryText;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new InventoryStatus());
} else {
  new InventoryStatus();
}
